import { render } from "./SlideshowSlide.vue?vue&type=template&id=68da79b8&lang=html"
import script from "./SlideshowSlide.vue?vue&type=script&lang=js"
export * from "./SlideshowSlide.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__